
// Import necessary modules
import React, { useEffect, useState } from 'react';
import { Hpe } from 'grommet-icons';
// import { hpe } from 'grommet/themes';
//import { useLocation } from 'react-router-dom';
import { HashRouter as Router, useHistory, Route, Routes } from 'react-router-dom';
import { hpe } from 'grommet-theme-hpe';
//import App from './App.js'; 
import axios from 'axios';
import { useLocation, useSearchParams, Outlet, useNavigate } from 'react-router-dom';
import { Accordion, AccordionPanel, List, Heading, Grommet, Menu, Anchor, Card, CardHeader, CardBody, CardFooter, Text, Box, Tabs, Tab, Image, Button, DropButton } from 'grommet';
///import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router-dom for routing
import SPPComponent from '../spp-page/SPPComponent.js';
import PatchComponent from '../patch-page/PatchComponent.js';
import { CircleInformation, Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import LicenseAgreementComponent from '../licenseagreement-page/LicenseAgreementComponent.js';
import { useTranslation } from 'react-i18next';
const theme = {
  global: {
    colors: {
      brand: '#0072c6', // HPE primary color
      background: {
        dark: '#111111',
        light: '#FFFFFF',
      },
    },
    font: {
      family: 'MetricBold, Arial, sans-serif', // or any other font family used in HPE design
    },
  },
  button: {
    border: {
      radius: '4px', // HPE button border radius
    },
  },
  card: {
    container: {
      background: '#F2F2F2', // HPE card background color
      elevation: 'medium', // HPE card elevation
    },
  },
  icon: {
    colors: {
      // Define icon colors for HPE theme
      favorite: 'red', // HPE favorite icon color
      share: 'plain', // HPE share icon color
    },
  },
};
////start
////end
const menuData = [
  {
    label: 'Gen11',
    link: '/'
  },
  {
    label: 'Gen10/Gen10 Plus',
    link: '/products',
    subItems: [
      { label: 'Product 1', link: '/products/1' },
      { label: 'Product 2', link: '/products/2' }
    ]
  },
  {
    label: 'Post Prod',
    link: '/about'
  },
  {
    label: 'Additional Resources',
    link: '/contact'
  }
];


// Define your App component
function MainComponent() {
  const { t } = useTranslation();
  
  // Get the part of the URL before the first slash
  // Get the base URL from the current location
  const basePath = window.location.origin;
  const pathName = window.location.pathname;
  const navigate = useNavigate();
  // Construct the dynamic path to the config.json file
  let configPath =  `${basePath}${pathName}assets/config.json`;
  console.log('configpath', configPath);

  const location = useLocation(); // Get the current location (URL)
  // Function to extract query parameters
  const getQueryParams = (param) => {
    const searchParams = new URLSearchParams(location.search); // Parse the query string
    return searchParams.get(param); // Return the value of the passed parameter (e.g., 'version')
  };

  const sppversion = getQueryParams('version'); // Get the 'version' parameter from the URL

  const [HomePage, setHomePage] = useState('');
  //debugger
  //const navigate = useNavigate();//uncomment
  const [activeItem, setActiveItem] = useState(null);
  const [showLicense, setShowLicense] = useState(false);
  const [version, setVersion] = useState(null);
  const [patchVersion, setPatchVersion] = useState(null);
  const [patchFlag, setPatchFlag] = useState(false);
  //const history = useHistory();//uncomment
  const [isVisibleMessage1, setIsVisible] = useState(true);
  const [isVisibleMessage2, setIsVisibleMessage] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState(null);
  const [tabData, setTabData] = useState(null);
  const [categorizedtabData, setCategorizeTabData] = useState(null);
  const [dataadditional, setAdditionalData] = useState(null);
  //const [categorizedData, setCategorizedData] = useState({});
  const [error, setError] = useState(null);


  // Get the version query parameter
  // const sppversion = searchParams.get('version');
  // const handleClick = (version) => {
  //   setVersion(version);
  //   navigate(`/SPPComponent/${version}`);
  // };//uncomment


  console.log("shruthi")
  const [gen10Data, setGen10Data] = useState([]);
  const [gen11Data, setGen11Data] = useState([]);
  const [gen12Data, setGen12Data] = useState([]);
  const [postProdData, setPostProdData] = useState([]);
  const [additionalresourceData, setAdditionalResourceData] = useState([]);

  const [gen10tabname, setGen10Tab] = useState(null);
  const [gen11tabname, setGen11Tab] = useState(null);
  const [postprodtabname, setPostProdTab] = useState(null);
  const [additionalresourcetabname, setAdditionalTab] = useState(null);
  // useEffect(() => {
  //   // Fetch the JSON data
  //   fetch('/assets/config.json')
  //     .then(response => response.json())
  //     .then(data => {
  //       setData(data);
  //       console.log(data);
  //     })
  //     .catch(error => console.error('Error fetching data:', error));
  // }, []);

  // useEffect(() => {
  //   // Fetch the JSON data
  //   fetch('/src/assets/config.json')
  //     .then(response => response.json())
  //     .then(data => {
  //       setData(data);
  //       categorizeData(data.ListOfSPPTabs);
  //       console.log(data)
  //     })
  //     .catch(error => console.error('Error fetching data:', error));
  // }, []);

  // const categorizeData = (tabs) => {
  //   const categories = tabs.reduce((acc, tab) => {
  //     if (!acc[tab.Generation]) {
  //       acc[tab.Generation] = [];
  //     }
  //     acc[tab.Generation].push(tab);
  //     return acc;
  //   }, {});    setCategorizedData(categories);
  // };

  // useEffect(() => {
  //   console.log('patchFlag updated:', patchFlag);
  // }, [patchFlag]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await fetch(configPath, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }); // Ensure this path points to the public directory
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const json = await response.json(); // Read and parse the response body as JSON
        console.log('Parsed JSON:', json); // Log parsed JSON to verify structure

        const data = json.ListOfSPPTabs;
        const dataadditional = json.AdditionalTabs;
        const HomePageVersion = json.HomePageSPPVersion;
        console.log('Homepageversion', HomePageVersion);
        setData(data);
        setAdditionalData(dataadditional);
        setHomePage(HomePageVersion);
        //setVersion(HomePageVersion);

        console.log(data)
        console.log(dataadditional);
        const tabdata = [];
        const gen10 = [];
        const gen11 = [];
        const gen12 = [];
        const postProd = [];
        const additionalresource = [];
        let additionalTableResource = [];
        let secondTableResource = [];

        //if (Array.isArray(dataadditional.FirstTable)) {
        // if (typeof dataadditional.FirstTable === 'object') {
        //   Object.entries(dataadditional.FirstTable).forEach(([key, tab]) => {
        //     const tabInfo = {
        //       general: tab.general,
        //       generalLink: tab.generalLink,
        //       SUMDocumentation: tab.SUMDocumentation,
        //       SUMDocumentationLink: tab.SUMDocumentationLink
        //     };
        //     additionalresource.push(tabInfo);
        //   });
        // }
        // if (typeof dataadditional.SecondTable === 'object') {
        //   Object.entries(dataadditional.SecondTable).forEach(([key, tab]) => {
        //     const tabInfo = {
        //       SPPDocumentation: tab.SPPDocumentation,
        //       SPPDocumentationLink: tab.SPPDocumentationLink,
        //       RepositoriesNRecipes: tab.RepositoriesNRecipes,
        //       RepositoriesNRecipesLink: tab.RepositoriesNRecipesLink
        //     };
        //     additionalresource.push(tabInfo);
        //   });
        // }
        //}

        if (typeof dataadditional.FirstTable === 'object') {
          Object.entries(dataadditional.FirstTable).forEach(([key, tab]) => {
            const tabInfoSPP = {
              label: tab.general,
              general: tab.general,
              generalLink: tab.generalLink,
            };
            const tabInfoRepo = {
              label: tab.SUMDocumentation,
              SUMDocumentation: tab.SUMDocumentation,
              SUMDocumentationLink: tab.SUMDocumentationLink,
            };
            additionalresource.push(tabInfoSPP);
            additionalresource.push(tabInfoRepo);
          });
        }

        if (typeof dataadditional.SecondTable === 'object') {
          Object.entries(dataadditional.SecondTable).forEach(([key, tab]) => {
            const tabInfoSPP = {
              label: tab.SPPDocumentation,
              SPPDocumentation: tab.SPPDocumentation,
              SPPDocumentationLink: tab.SPPDocumentationLink,
            };
            const tabInfoRepo = {
              label: tab.RepositoriesNRecipes,
              RepositoriesNRecipes: tab.RepositoriesNRecipes,
              RepositoriesNRecipesLink: tab.RepositoriesNRecipesLink,
            };
            additionalresource.push(tabInfoSPP);
            additionalresource.push(tabInfoRepo);
          });
        }
        setAdditionalResourceData(additionalresource);
        console.log('last log', additionalresourceData);

        const now = new Date();
        const eighteenMonthsAgo = new Date();
        eighteenMonthsAgo.setMonth(now.getMonth() - 18);
        console.log('length', json.ListOfSPPTabs.length)
        // Assuming data is an array
        for (let i = 0; i < json.ListOfSPPTabs.length; i++) {
          const tab = json.ListOfSPPTabs[i];
          console.log(i, tab);
          if (Array.isArray(tab.SPPs)) {
            for (let j = 0; j < tab.SPPs.length; j++) {
              const spp = tab.SPPs[j];
              const releaseDate = new Date(spp.ReleaseDate);
              if (tab.Generation === "PostProd") {
                const tabInfo = {
                  PatchBundles: spp.PatchBundles ? spp.PatchBundles : [],
                  DisplayTabName: tab.DisplayTabName,
                  BundleVersion: spp.BundleVersion,
                  ReleaseDate: spp.ReleaseDate,
                  Generation: tab.Generation
                };
                if (tabInfo.BundleVersion != "Gen9.0") {
                  postProd.push(tabInfo);
                  tabdata.push(tabInfo);
                }
              }
              else if (releaseDate >= eighteenMonthsAgo) {
                const tabInfo = {
                  PatchBundles: spp.PatchBundles ? spp.PatchBundles : [],
                  DisplayTabName: tab.DisplayTabName,
                  BundleVersion: spp.BundleVersion,
                  ReleaseDate: spp.ReleaseDate,
                  Generation: tab.Generation
                };

                switch (tab.Generation) {
                  case 'gen10':
                    gen10.push(tabInfo);
                    tabdata.push(tabInfo);
                    break;
                  case 'gen11':
                    gen11.push(tabInfo);
                    tabdata.push(tabInfo);
                    break;
                  case 'PostProd':
                    if (tabInfo.BundleVersion != "Gen9.0") {
                      postProd.push(tabInfo);
                      tabdata.push(tabInfo);
                    }
                    break;
                  case 'gen12':
                    gen12.push(tabInfo);
                    tabdata.push(tabInfo);
                    break;
                  default:
                    break;
                }
              }
              else if (i == 2) {
                const tabInfo = {
                  PatchBundles: spp.PatchBundles ? spp.PatchBundles : [],
                  DisplayTabName: tab.DisplayTabName,
                  BundleVersion: spp.BundleVersion,
                  ReleaseDate: spp.ReleaseDate
                };
                if (tabInfo.BundleVersion != "Gen9.0" && tabInfo.Generation === "PostProd") {
                  postProd.push(tabInfo);
                  tabdata.push(tabInfo);
                }
              }
            }
          }
        }

        setGen10Data(gen10);
        setGen11Data(gen11);
        setGen12Data(gen12);
        setPostProdData(postProd);
        setTabData(tabdata);
        //setAdditionalResourceData(additionalresource);
        console.log('PatchBundles', gen11[0].PatchBundles);
        console.log('gen11', gen11Data);
        console.log('PostProddata', postProdData);
        console.log('addresend', additionalresourceData);
        console.log('TabData', tabData);
        console.log('gen12data', gen12Data);
        //const categorizedData = categorizeData(tabData);
        //console.log(categorizedData);
        //setCategorizeTabData(categorizeData);

        // if(gen10.length > 0)
        // {
        //   gen10tabname = gen10[0].DisplayTabName;
        // }
        // if(gen11.length > 0){
        //   gen11tabname = gen11[0].DisplayTabName;
        // }
        // if(postProd.length > 0)
        // {
        //   postprodtabname = postProd[0].DisplayTabName;
        // }
        console.log('gen10', gen10);
        console.log('gen11', gen11);
        console.log('gen12', gen12);
        console.log('postprod', postProd);
        console.log('add res', additionalresource);


        //additionalresourcetabname = 'Additional Reources';

      } catch (error) {
        console.error('Error fetching or parsing the JSON file:', error); // Log fetching and parsing errors
        setError(`Error fetching or parsing the JSON file: ${error.message}`);
      } finally {
        //setLoading(false);
      }
    };

    fetchData();
  }, []);

  const onLinkClick = (link) => {
    console.log('licenselink', link);
    //debugger
    if (link.includes('/licenseagreements')) {
      //setShowLicense(true);
      navigate(`/spp/licenseagreements`);
      //<LicenseAgreementComponent></LicenseAgreementComponent>
    }
    else {
      //setShowLicense(false);
      window.open(link, "_blank");
    }

    // if (link.startsWith("/")) {
    //   navigate(link);
    // } else {
    //   window.open(link, "_blank");
    // }
  };

  // useEffect(() => {
  //   if (version) {
  //     history.push(`/SPPComponent/${version}`);
  //   }
  // }, [version, history]);

  useEffect(() => {
    console.log('additionalresourceData:', additionalresourceData);
  }, [additionalresourceData]);

  useEffect(() => {
    console.log('additionalresourceData:', gen11Data);
  }, [gen11Data]);
  // fetch('./data.json', { method: "GET" })
  // .then(res => return res.json())
  // .then(text => console.log(text))

  //   fetch('assets/config.json')
  // .then(response => {
  //   console.log('inside');
  //   console.log(response);
  //   if (!response.ok) {
  //     throw new Error('Network response was not ok ' + response.statusText);
  //   }
  //   return response.text(); // Get the raw response
  // })
  // .then(text => {
  //   console.log(text); // Inspect the raw response
  //   const data = JSON.parse(text); // Manually parse the JSON
  //   setData(data);
  // })
  // .catch(error => setError(error));

  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch('./src/config.json', { method: "GET" }); // Path to your JSON file in public directory
  //       if (!response.ok) {
  //         throw new Error(`Network response was not ok: ${response.statusText}`);
  //       }
  //       const text = await response.text();
  //       console.log('Raw Response Text:', text);

  //       const json = await response.json();
  //       console.log('Parsed JSON:', json); 

  //       try {
  //         const json = JSON.parse(text);
  //         console.log('Parsed JSON:', json);
  //         setData(json);
  //       } catch (jsonError) {
  //         throw new Error('Error parsing JSON: ' + jsonError.message);
  //       }

  //     } catch (error) {
  //       console.error('Error fetching the JSON file:', error);
  //       setError(error.message);
  //     } finally {
  //      // setLoading(false);
  //      console.log('finally');
  //     }
  //   };

  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   
  //   // fetch('config.json')
  //   //     .then(response => response.json())
  //   //     .then(data => {
  //   //       //data = response.data.ListOfSPPTabs;
  //   //       setData(data.ListOfSPPTabs);
  //   //       setAdditionalData(data.AdditionalTabs);
  //   //       //dataadditional = response.data.AdditionalTabs;
  //   //       console.log(data)
  //   //       console.log(dataadditional);
  //   //     })
  //       // .catch(error => console.error('Error fetching data:', error));
  //   const fetchData = async () => {
  //     try {

  //       const response = await axios.get('/config.json'); // Adjust the path to your config file
  //         // Fetch the JSON data

  //       const data = response.data.ListOfSPPTabs;
  //       const dataadditional = response.data.AdditionalTabs;
  //       setData(data);
  //       setAdditionalData(dataadditional);
  //       //dataadditional = response.data.AdditionalTabs;
  //   //       console.log(data)
  //   //       console.log(dataadditional);


  //       const gen10 = [];
  //       const gen11 = [];
  //       const postProd = [];
  //       const additionalresource = []

  //       dataadditional.forEach(tab => {
  //         tab.AdditionalTabs.forEach(spp => {
  //           const tabInfo = {
  //             DisplayTabName: tab.FirstTable.general,
  //             BundleVersion: tab.FirstTable.generalLink
  //           };
  //           switch (tab.AdditionalTabs) {
  //             case 'Additional Resources':
  //               additionalresource.push(tabInfo);
  //               setAdditionalTab(tabInfo.DisplayTabName);
  //               break;
  //             default:
  //               break;
  //           }
  //         });

  //       });

  //       data.forEach(tab => {
  //         tab.SPPs.forEach(spp => {
  //           const tabInfo = {
  //             DisplayTabName: tab.DisplayTabName,
  //             BundleVersion: spp.BundleVersion
  //           };
  //           switch (tab.Generation) {
  //             case 'gen10':
  //               gen10.push(tabInfo);
  //               setGen10Tab(tabInfo.DisplayTabName);
  //               break;
  //             case 'gen11':
  //               gen11.push(tabInfo);
  //               setGen11Tab(tabInfo.DisplayTabName);
  //               break;
  //             case 'PostProd':
  //               postProd.push(tabInfo);
  //               setPostProdTab(tabInfo.DisplayTabName);
  //               break;
  //             default:
  //               break;
  //           }
  //         });
  //       });

  //       setGen10Data(gen10);
  //       setGen11Data(gen11);
  //       setPostProdData(postProd);
  //       setAdditionalResourceData(additionalresource);
  //       console.log('gen10', gen10);
  //       console.log('gen11', gen11)
  //     } catch (error) {
  //       console.error('Error fetching config:', error);
  //     }
  //   };

  //   fetchData();
  // }, []);
  // const renderMenu = (title, data) => (
  //   <Menu
  //     label={title}
  //     items={data.map((item, index) => ({
  //       label: `${item.BundleVersion}`,
  //       onClick: () => console.log(`${item.BundleVersion}`),
  //       items: item.PatchBundles?.slice(0, 3).map((bundle, bundleIndex) => ({
  //         label: item.PatchBundles.Name,
  //         onClick: () => console.log(`Patch Bundle: ${item.PatchBundles.Name}`)
  //       })) || []
  //     }))}
  //   />
  // );
  const renderAdditionalMenu = (title, data) => (
    <Menu
      label={title}
      items={data.map((item, index) => ({
        label: item.label,
        onClick: () => onLinkClick(item.generalLink || item.SUMDocumentationLink || item.RepositoriesNRecipesLink || item.SPPDocumentationLink),
        items: [
          item.general && { label: `General Link: ${item.generalLink}`, onClick: () => onLinkClick(item.generalLink) },
          item.SUMDocumentation && { label: `SUM Documentation: ${item.SUMDocumentationLink}`, onClick: () => onLinkClick(item.SUMDocumentationLink) },
          item.RepositoriesNRecipes && { label: `Repositories and Recipes: ${item.RepositoriesNRecipesLink}`, onClick: () => onLinkClick(item.RepositoriesNRecipesLink) }
        ].filter(Boolean)
      }))}
    />
  );


  // Function to update both patchVersion and patchFlag
  const updatePatchVersion = (newVersion) => {
    if (newVersion != "No Patches") {
      //setPatchVersion(newVersion);
      //setPatchFlag(true);
      //setShowLicense(false);
      navigate(`/patch/index.aspx?version=${newVersion}`);
    }
    // <PatchComponent patchVersion={newVersion}></PatchComponent>
  };

  const handleVersionUpdate = (item) => {
    console.log('click event post prod', item);
    // Check if the Generation is neither 'gen10' nor 'gen11'

    if (item.Generation == "PostProd") {
          console.log('Sunita not adding postprod: ', item.DisplayTabName);

      updateSPPVersion(item.BundleVersion);
    }
    else {
        console.log('Sunita  adding postprod 11:', item.DisplayTabName);

      const generation = item.Generation.toLowerCase(); // Ensure case-insensitivity
      updateSPPVersion(generation + '.' + item.BundleVersion);
     // updateSPPVersion( item.BundleVersion);
    }
  };

  // Function to update both patchVersion and patchFlag
  const updateSPPVersion = (newVersion) => {
    //debugger
    //setVersion(newVersion);
    // setPatchVersion("");
    //setPatchFlag(false);
    //setShowLicense(false);
    // <SPPComponent version={newVersion}> </SPPComponent>
    
    navigate(`/index.aspx?version=${newVersion}`);
  };

  const groupByGeneration = (data) => {
    console.log('grpdta', data);
    return data.reduce((acc, item) => {
      // Skip items where Generation is undefined
      if (!item.Generation) {
        return acc;
      }

      let groupKey;

      // Grouping logic based on Generation
      if (item.Generation === 'gen10') {
        groupKey = 'gen10';
      } else if (item.Generation === 'gen11') {
        groupKey = 'gen11';
      } else if (item.Generation === 'gen12') {
        groupKey = 'gen12';
      } else if (item.Generation === 'PostProd') {
        groupKey = 'PostProd';
      }
      else {
        // Skip items with unknown or unexpected Generation values
        return acc;
      }

      // Initialize group if it doesn't exist
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }

      // Push item into the correct group
      acc[groupKey].push(item);
      return acc;
    }, {});
  };


  // Determine the component to render based on the URL
  // const renderComponent = () => {
  //   debugger
  //   console.log('inside render', HomePage);
  //   console.log('inside', sppversion);
  //   if (pathname.startsWith('/index')) {
  //     // If 'version' parameter is present, send it to SPPComponent
  //     if (version) {
  //       // setVersion(sppversion);
  //       return <SPPComponent version={sppversion} />;
  //     } else {
  //       return <SPPComponent version={HomePage} />;
  //     }
  //   } else if (pathname.startsWith('/patch/')) {
  //     //setPatchVersion(sppversion);
  //     return <PatchComponent patchVersion={sppversion} />;
  //   } else if (pathname === 'licenseagreements') {
  //     return <LicenseAgreementComponent />;
  //   } else {
  //     //setVersion(HomePage);
  //     return <MainComponent />;
  //   }
  // };

  // useEffect(() => {
  //   // You can update states here if needed
  //   if (pathname.startsWith('/index')) {
  //     // If 'version' parameter is present, render SPPComponent with version
  //     return version ? <SPPComponent version={sppversion} /> : <SPPComponent version="HomePage" />;
  //   } else if (pathname.startsWith('/patch/')) {
  //     // Render PatchComponent for patch versions
  //     return <PatchComponent patchVersion={sppversion} />;
  //   } else if (pathname === 'licenseagreements') {
  //     // Render LicenseAgreementComponent
  //     return <LicenseAgreementComponent />;
  //   } else {
  //     // Default return MainComponent
  //     return <MainComponent />;
  //   }

  // }, [pathname]); // Ensure you update state only when pathname changes


  // const groupByGeneration = (data) => {
  //   return data.reduce((acc, item) => {
  //     if (!acc[item.Generation]) {
  //       acc[item.Generation] = [];
  //     }
  //     acc[item.Generation].push(item);
  //     return acc;
  //   }, {});
  // };
  //Rendermeu using dropbutton
  // const renderMenu = (title, data) => {
  //   const groupedData = groupByGeneration(data);

  //   return (
  //     <Box>
  //       {Object.keys(groupedData).map((generation, index) => {
  //         const items = groupedData[generation];

  //         const patchBundlesLabel = items.map(item => (
  //           (Array.isArray(item.PatchBundles) ? item.PatchBundles : Object.values(item.PatchBundles))
  //             .map(bundle => (
  //               <Button plain onClick={() => updatePatchVersion(item.Generation + '.' + bundle.Name)} key={bundle.Name}>
  //                 <Text size="medium">{bundle.Name}</Text>
  //               </Button>
  //             ))
  //         ));

  //         return (
  //           <DropButton
  //             key={index}
  //             label={`${title}`}
  //             dropAlign={{ top: 'bottom', left: 'left' }}
  //             dropContent={
  //               <Box width="300px" align="start" pad="small" gap="small">
  //                 <Box direction="column" gap="small">
  //                   <Box direction="row" gap="small">
  //                     <Text size="medium">Base SPP</Text>
  //                   </Box>
  //                   <Box direction="row" gap="small">
  //                     {items.map(item => (
  //                       <Button plain onClick={() => handleVersionUpdate(item)} key={item.BundleVersion}>
  //                         <Text>{item.BundleVersion}</Text>
  //                       </Button>
  //                     ))}
  //                   </Box>
  //                 </Box>

  //                 <Box direction="column" gap="small">
  //                   <Box direction="row" gap="medium">
  //                     <Text size="medium">Patch Bundles</Text>
  //                   </Box>
  //                   {patchBundlesLabel.flat().length > 0 ? (
  //                     <Box direction="column" gap="small">
  //                       {patchBundlesLabel}
  //                     </Box>
  //                   ) : (
  //                     <Text size="small">No Patches</Text>
  //                   )}
  //                 </Box>
  //               </Box>
  //             }
  //           />
  //         );
  //       })}
  //     </Box>
  //   );
  // };

  const renderMenu = (title, data) => {
    const groupedData = groupByGeneration(data);
    console.log('grouped data', groupedData);
    //const groupedData = data;

    return (
      <Box>
        {Object.keys(groupedData).map((generation, index) => {
          const items = groupedData[generation];

          // Check if 'items' is an array, otherwise initialize it as an empty array
          const itemsArray = Array.isArray(items) ? items : [];

          return (
            <DropButton
              key={index}
              // label={`${title}`}
              label={
                <Box align="start" justify="start" width="100%">
                  <Text textAlign="start">{`${title}`}</Text>
                </Box>
              }
              dropAlign={{ top: 'bottom', left: 'left' }}
              dropContent={
                <Box width="280px" align="start" pad="small" gap="small">
                  {/* Loop through Base SPP items and show Patch Bundles next to each */}
                  {itemsArray.map((item, idx) => {
                    const patchBundles = Array.isArray(item.PatchBundles)
                      ? item.PatchBundles
                      : Object.values(item.PatchBundles);

                    return (
                      <Box key={idx} direction="row" gap="small" align="start" fill="horizontal">
                        {/* Base SPP Section */}
                        <Box direction="column" gap="xxsmall" flex>
                          {idx === 0 && (
                            <Text weight="bold" size="medium">Base SPP</Text>
                          )}
                          <Button plain onClick={() => handleVersionUpdate(item)}>
                            <Text>{item.BundleVersion}</Text>
                          </Button>
                        </Box>

                        {/* Patch Bundles Section */}
                        <Box direction="column" gap="xxsmall" flex>
                          {idx === 0 && (
                            <Text weight="bold" size="medium">Patch Bundles</Text>
                          )}
                          {patchBundles.length > 0 ? (
                            patchBundles.map((bundle, i) => (
                              <Button plain key={i} onClick={() => updatePatchVersion(item.Generation + '.' + bundle.Name)}>
                                <Text>{bundle.Name}</Text>
                              </Button>
                            ))
                          ) : (
                            <Box pad={{ vertical: 'xxsmall' }}>
                              <Text size="small">{t('NoPatches')}</Text>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              }
            />
          );
        })}
      </Box>
    );
  };


  //using menu control working
  // const renderMenu = (title, data) => (
  //   <Menu
  //     justify="start"
  //     label={title}
  //     items={data.map((item, index) => {
  //       // Create a list of PatchBundle labels
  //       const patchBundlesLabel = (Array.isArray(item.PatchBundles) ? item.PatchBundles : Object.values(item.PatchBundles))
  //         .map(bundle => (
  //           <Button default onClick={() => updatePatchVersion(item.Generation + '.' + bundle.Name)} key={bundle.Name}>
  //             <Text size="medium">{bundle.Name}</Text>
  //           </Button>
  //         ));

  //       return {
  //         label: (
  //           <Box width="300px" align="start" direction="row" pad="small" gap="small">
  //             <Box direction="column" gap="small">
  //               <Box direction="row" gap="small">
  //                 <Text size="medium">Base SPP</Text>
  //               </Box>
  //               <Box  direction="row" gap="small">
  //                 <Button default onClick={() => handleVersionUpdate(item)}>
  //                   <Text>{item.BundleVersion}</Text>
  //                 </Button>
  //               </Box>
  //             </Box>

  //             <Box direction="column" gap="small">
  //               <Box direction="row" gap="medium">
  //                 <Text size="medium">Patch Bundles</Text>
  //               </Box>
  //               {patchBundlesLabel.length > 0 ? (
  //                 <Box  direction="column" gap="small">
  //                   {patchBundlesLabel}
  //                 </Box>
  //               ) : (
  //                 <Text size="small">No Patches</Text>
  //               )}
  //             </Box>
  //           </Box>
  //         ),
  //         items: patchBundlesLabel.length > 0 ? patchBundlesLabel : [{ label: <Text size="small">No Patches</Text> }]
  //       };
  //     })}
  //   />

  // );

  const categorizeData = (data) => {
    return data.reduce((acc, item) => {
      const generation = item.Generation.toLowerCase();
      if (!acc[generation]) {
        acc[generation] = [];
      }
      acc[generation].push(item);
      return acc;
    }, {});
  };



  const handleTabChange = (index) => {
    setActiveIndex(index);
  };

  const handleClose1 = () => {
    setIsVisible(false);
  };
  const handleClose2 = () => {
    setIsVisibleMessage(false);
  };
  return (
    // <Grommet theme={hpe}>
    <Grommet themeMode="light" theme={hpe}>
      {/* <Image src="assets/HPESymbol.JPG" alt="HPE LOGO" /> */}


      {/* Example Menu with multiple subitems */}
      <Box background="light-2"  direction="row" pad="medium" gap="medium">
        {/* <>
          {tabData && tabData.length > 0 && tabData.map((gen, index) => (
            gen.data && gen.data.length > 0 && (
              <>
                {renderMenu(gen.title, gen.data)}
              </>
            )
          ))}
        </> */}
        {renderMenu('Gen12', gen12Data)}
        {renderMenu('Gen11', gen11Data)}
        {renderMenu('Gen10/Gen10 Plus', gen10Data)}
        {renderMenu(t('PostProduction'), postProdData)}

        {/* <>
          {categorizedtabData && Object.keys(categorizedtabData).map((generation) => (
            categorizedtabData[generation] && categorizedtabData[generation].length > 0 && (
              <>
                {renderMenu(generation.charAt(0).toUpperCase() + generation.slice(1), categorizedtabData[generation])}
              </>
            )
          ))}
        </> */}

        {renderAdditionalMenu(t('AdditionalResources'), additionalresourceData)}
      </Box>

      {/* { type ==='spp' ? <SPPComponent version={xyz}></SPPComponent> : <} */}
      {/* Render SPPComponent only if patchVersion is not set */}
      {/* Conditional rendering */}

      {/* {renderComponent()} */}
      {/* {patchFlag && patchVersion ? (
        <PatchComponent patchVersion={patchVersion} />
      ) : (
        <SPPComponent version={version} setPatchFlag={setPatchFlag} setPatchVersion={setPatchVersion} />
      )} */}


      {/* The Outlet renders the nested route components */}
      <Outlet />

    </Grommet>
  );
}

MainComponent.propTypes = {
  //setVersion: PropTypes.func,
  //setPatchVersion: PropTypes.func,
  // setPatchFlag: PropTypes.func
  //setPatchFlag:PropTypes.func
};


export default MainComponent;